import React from "react";
import { useLocalization } from "../../localization/LocalizationContext";

function ReportReview({ reportData, widgets }) {
  const {localizationStrings} = useLocalization();
  const { reportName, description, dataType = [] } = reportData || {};

  // Merge widgets into dataType if widgets prop is provided
  const selectedWidgets = widgets?.length
    ? widgets.map((widget) => ({
        widget_name_ui: widget.widget_name_ui,
        widget_desc: widget.widget_desc,
      }))
    : dataType;

  return (
    <div>
      <h4>{localizationStrings?.review}</h4>
      <p>
        {localizationStrings?.reportReviewInfo}
      </p>
      <div className="accordion" id="accordionReview">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {localizationStrings?.reportDetails}
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionReview"
          >
            <div className="accordion-body">
              <div className="d-flex">
                <div className="p-report">
                  <label className="form-label">{localizationStrings?.reportName}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={reportName || ""}
                    readOnly
                  />
                </div>
                <div className="r-profile">
                  <label className="form-label">{localizationStrings?.description}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={description || ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Accordion for Widgets */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {localizationStrings?.widgets}
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionReview"
          >
            <div className="accordion-body">
              <div className="inc-card-table">
                <table className="m-head">
                  <thead>
                    <tr>
                      <th>{localizationStrings?.widgetName}</th>
                      <th>{localizationStrings?.description}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedWidgets.length > 0 ? (
                      selectedWidgets.map((widget, index) => (
                        <tr key={index}>
                          <td>{widget.widgetName}</td>
                          <td>{widget.widgetDesc}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2">{localizationStrings?.noWidgetSelected}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportReview;
